import { render, staticRenderFns } from "./PassengerModal.vue?vue&type=template&id=33ec885c&scoped=true&"
import script from "./PassengerModal.vue?vue&type=script&lang=js&"
export * from "./PassengerModal.vue?vue&type=script&lang=js&"
import style0 from "./PassengerModal.vue?vue&type=style&index=0&id=33ec885c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec885c",
  null
  
)

export default component.exports